export default __webpack_public_path__ + "static/media/dropbox.21defefc.svg";